import Subscription from "@/ts/User/Types/Subscription";import ApiClient from "@/ts/Utility/ApiClient";

export default class SubscriptionRepository {
    public static async getAll(): Promise<Subscription[]> {
        return await ApiClient.get<Subscription[]>('subscriptions');
    }
}
